import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="securestorage" id="securestorage"></a>
    <h1 {...{
      "id": "requireuxpstoragesecurestorage"
    }}>{`require('uxp').storage.secureStorage`}</h1>
    <p>{`SecureStorage provides a protected storage which can be used to store sensitive data
per plugin. SecureStorage takes a key-value pair and encrypts the value before being
stored. After encryption, it stores the key and the encrypted value pair. When the value
is requested with an associated key, it's retrieved after being decrypted. Please note
that the key is not encrypted thus it's not protected by the cryptographic operation.`}</p>
    <p>{`Caveats for SecureStorage are as follows:`}</p>
    <ol>
      <li parentName="ol">{`SecureStorage is not an appropriate storage for sensitive data which wants to keep
secret from the current user. SecureStorage is protected under the current user's
account credential. It means the encrypted data can be at risk of being decrypted
with the current user's privilege.`}</li>
      <li parentName="ol">{`Data in SecureStorage can be lost for various reasons. For an example, the user
could uninstall the host application and delete the secure storage. Or, the cryptographic
information used by the secure storage could be damaged by the user accidentally, and
it will result in loss of data without the secure storage being removed. SecureStorage
should be regarded as a cache rather than a persistent storage. Data in SecureStorage
should be able to be regenerated from plugins after the time of loss.`}</li>
    </ol>
    <a name="securestorage-length" id="securestorage-length"></a>
    <h2 {...{
      "id": "length--number"
    }}>{`length : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
Number of items stored in the secure storage.`}</p>
    <a name="securestorage-setitem" id="securestorage-setitem"></a>
    <h2 {...{
      "id": "setitemkey-value"
    }}>{`setItem(key, value)`}</h2>
    <p>{`Stores a key and value pair after the value is encrypted in a secure storage.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise<void>`}</inlineCode>{` Promise that resolves when the value is stored, rejected when the value is empty or not stored.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`TypeError`}</inlineCode>{` If either key or value doesn't have one of acceptable types.`}</li>
    </ul>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`key`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Key to set value`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`value`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`ArrayBuffer`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`TypedArray`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Value for a key.`}</td>
        </tr>
      </tbody>
    </table>
    <a name="securestorage-getitem" id="securestorage-getitem"></a>
    <h2 {...{
      "id": "getitemkey"
    }}>{`getItem(key)`}</h2>
    <p>{`Retrieves a value associated with a provided key after the value is being decrypted from a secure storage.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise<Uint8Array>`}</inlineCode>{` Promise that resolves with an Uint8Array`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`TypeError`}</inlineCode>{` If a key doesn't have an acceptable type.`}</li>
    </ul>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`key`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Key to get value`}</td>
        </tr>
      </tbody>
    </table>
    <a name="securestorage-removeitem" id="securestorage-removeitem"></a>
    <h2 {...{
      "id": "removeitemkey"
    }}>{`removeItem(key)`}</h2>
    <p>{`Removes a value associated with a provided key.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise<void>`}</inlineCode>{` Promise that resolves when the value associated with the key is removed, rejected when the value is neither removed nor found.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`TypeError`}</inlineCode>{` If a key doesn't have an acceptable type.`}</li>
    </ul>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`key`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Key to remove value`}</td>
        </tr>
      </tbody>
    </table>
    <a name="securestorage-key" id="securestorage-key"></a>
    <h2 {...{
      "id": "keyindex"
    }}>{`key(index)`}</h2>
    <p>{`Returns a key which is stored at the given index.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`number`}</inlineCode>{` - Key which is stored at the given index.  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`index`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Integer representing the number of the key`}</td>
        </tr>
      </tbody>
    </table>
    <a name="securestorage-clear" id="securestorage-clear"></a>
    <h2 {...{
      "id": "clear"
    }}>{`clear()`}</h2>
    <p>{`Clear all values in a secure storage.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise<void>`}</inlineCode>{` Promise that resolves when all the items are cleared. rejected when there is no item to clear or clear failed.  `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      